import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { site } from "@/data/content";

export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  return (
    <>
      <Seo
        title={(isPrivacy ? "Privacy policy" : "Cookie policy") + " — " + site.name}
        description={
          isPrivacy
            ? "Come vengono trattati i dati inviati tramite il modulo di contatto del sito di Luisa Miceli."
            : "Informativa cookie del sito personale di Luisa Miceli."
        }
      />
      <section className="pt-36 lg:pt-44 pb-24 lg:pb-32 min-h-[60vh]">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bordeaux">Note legali</p>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl">
            {isPrivacy ? "Privacy policy" : "Cookie policy"}
          </h1>

          {isPrivacy ? (
            <Reveal>
              <div className="mt-10 space-y-6 text-sm font-light leading-relaxed text-ink2">
                <p>
                  Questo sito non richiede registrazione né creazione di account. I dati che decidi di
                  inviare tramite il modulo dei contatti — nome, indirizzo email, oggetto e messaggio —
                  sono utilizzati esclusivamente per rispondere alla tua richiesta e sono conservati nel
                  database del sito. Non vengono ceduti a terzi per finalità di marketing.
                </p>
                <p>
                  Il consenso al trattamento è necessario per l'invio del messaggio: senza di esso non è
                  possibile risponderti. Puoi chiedere in qualsiasi momento la rimozione dei dati che ti
                  riguardano scrivendo tramite il modulo dei contatti.
                </p>
                <p>
                  I link verso i rivenditori (quando presenti) portano a siti di terze parti le cui
                  informative privacy sono consultabili sui rispettivi siti.
                </p>
              </div>
            </Reveal>
          ) : (
            <Reveal>
              <div className="mt-10 space-y-6 text-sm font-light leading-relaxed text-ink2">
                <p>
                  Questo sito non utilizza cookie di tracciamento propri né script pubblicitari. Possono
                  essere presenti strumenti tecnici e di misura aggregata forniti dalla piattaforma di
                  pubblicazione, configurati nel rispetto della normativa applicabile.
                </p>
                <p>
                  I contenuti sono forniti in sola lettura: non vengono impostate preferenze o identificativi
                  di profilazione da parte del sito.
                </p>
              </div>
            </Reveal>
          )}
        </div>
      </section>
    </>
  );
}
